// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Styles */
.ReadMore_container__tTjSD {
  width: 100%;
  background-color: #1a1a1a;
  padding-top: 80px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* New Boxed Wrapper */
.ReadMore_boxContainer__zE2rW {
  width: 100%;
  max-width: 1400px;
  background-color: #1A1A1A;
  padding: 2rem;
  border-radius: 12px;
}

/* Title Styling */
.ReadMore_title__vxIBw {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
  color: white;
}

/* Grid Layout */
.ReadMore_gridContainer__ggyEo {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Grid Items */
.ReadMore_gridItem__V9q6x {
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
  /* Set a consistent aspect ratio */
  aspect-ratio: 3/4;
}

.ReadMore_gridItem__V9q6x:hover {
  transform: translateY(-5px);
}

/* Image Styling */
.ReadMore_imageContainer__NguVP {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.ReadMore_image__lu5DG {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

/* Overlay Effect */
.ReadMore_overlay__9Ov\\+2 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.5) 50%,
    transparent 100%
  );
  transition: opacity 0.3s ease;
}

/* Book Title */
.ReadMore_bookTitle__iG5EU {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: white;
}

/* Genre Text */
.ReadMore_genre__nrN8W {
  font-size: 0.9rem;
  color: #cccccc;
}

/* Pagination */
.ReadMore_pagination__c6zjA {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1rem;
}

/* Pagination Buttons */
.ReadMore_pageButton__kL\\+P0 {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  border: 1px solid #333;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ReadMore_pageButton__kL\\+P0:hover:not(:disabled) {
  background-color: #333;
}

.ReadMore_pageButton__kL\\+P0:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Next Button Styling */
.ReadMore_nextButton__2Zic7 {
  background-color: #E50000;
  border: none;
}

.ReadMore_nextButton__2Zic7:hover:not(:disabled) {
  background-color: #ff1a1a;
}

/* Page Indicator */
.ReadMore_pageIndicator__rRj9x {
  color: #666;
  font-size: 0.9rem;
}

/* Loading and Error States */
.ReadMore_loading__rKLpY, .ReadMore_error__6SlBC {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
  color: white;
}

/* Responsive Adjustments */
@media (max-width: 1200px) {
  .ReadMore_gridContainer__ggyEo {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .ReadMore_gridContainer__ggyEo {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
  
  .ReadMore_container__tTjSD {
    padding-top: 60px;
  }
  
  .ReadMore_boxContainer__zE2rW {
    width: 95%;
    padding: 1.5rem;
  }
  
  .ReadMore_title__vxIBw {
    font-size: 1.7rem;
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 480px) {
  .ReadMore_gridContainer__ggyEo {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.2rem;
    max-width: 95%;
    margin: 0 auto;
  }
  .ReadMore_container__tTjSD{
    min-height: auto;
  }
  .ReadMore_gridItem__V9q6x {
    aspect-ratio: auto;
  }
  
  .ReadMore_title__vxIBw {
    font-size: 1.4rem;
  }
  
  .ReadMore_boxContainer__zE2rW {
    width: 100%;
    padding: 0rem;
    border-radius: 8px;
  }
  
  .ReadMore_container__tTjSD {
    padding-top: 40px;
  }
  
  .ReadMore_pagination__c6zjA {
    flex-direction: row;
    gap: 0.5rem;
  }
  
  .ReadMore_pageButton__kL\\+P0 {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/ReadMore.module.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb;;;;;GAKC;EACD,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;IACX,cAAc;IACd,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":["/* Container Styles */\n.container {\n  width: 100%;\n  background-color: #1a1a1a;\n  padding-top: 80px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* New Boxed Wrapper */\n.boxContainer {\n  width: 100%;\n  max-width: 1400px;\n  background-color: #1A1A1A;\n  padding: 2rem;\n  border-radius: 12px;\n}\n\n/* Title Styling */\n.title {\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  text-align: center;\n  color: white;\n}\n\n/* Grid Layout */\n.gridContainer {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n/* Grid Items */\n.gridItem {\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  /* Set a consistent aspect ratio */\n  aspect-ratio: 3/4;\n}\n\n.gridItem:hover {\n  transform: translateY(-5px);\n}\n\n/* Image Styling */\n.imageContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n/* Overlay Effect */\n.overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1rem;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.9) 0%,\n    rgba(0, 0, 0, 0.5) 50%,\n    transparent 100%\n  );\n  transition: opacity 0.3s ease;\n}\n\n/* Book Title */\n.bookTitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n/* Genre Text */\n.genre {\n  font-size: 0.9rem;\n  color: #cccccc;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding: 1rem;\n}\n\n/* Pagination Buttons */\n.pageButton {\n  padding: 0.75rem 1.5rem;\n  background-color: transparent;\n  border: 1px solid #333;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pageButton:hover:not(:disabled) {\n  background-color: #333;\n}\n\n.pageButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Next Button Styling */\n.nextButton {\n  background-color: #E50000;\n  border: none;\n}\n\n.nextButton:hover:not(:disabled) {\n  background-color: #ff1a1a;\n}\n\n/* Page Indicator */\n.pageIndicator {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* Loading and Error States */\n.loading, .error {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.2rem;\n  color: white;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1200px) {\n  .gridContainer {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .gridContainer {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n  }\n  \n  .container {\n    padding-top: 60px;\n  }\n  \n  .boxContainer {\n    width: 95%;\n    padding: 1.5rem;\n  }\n  \n  .title {\n    font-size: 1.7rem;\n    margin-bottom: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gridContainer {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.2rem;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  .container{\n    min-height: auto;\n  }\n  .gridItem {\n    aspect-ratio: auto;\n  }\n  \n  .title {\n    font-size: 1.4rem;\n  }\n  \n  .boxContainer {\n    width: 100%;\n    padding: 0rem;\n    border-radius: 8px;\n  }\n  \n  .container {\n    padding-top: 40px;\n  }\n  \n  .pagination {\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n  \n  .pageButton {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReadMore_container__tTjSD`,
	"boxContainer": `ReadMore_boxContainer__zE2rW`,
	"title": `ReadMore_title__vxIBw`,
	"gridContainer": `ReadMore_gridContainer__ggyEo`,
	"gridItem": `ReadMore_gridItem__V9q6x`,
	"imageContainer": `ReadMore_imageContainer__NguVP`,
	"image": `ReadMore_image__lu5DG`,
	"overlay": `ReadMore_overlay__9Ov+2`,
	"bookTitle": `ReadMore_bookTitle__iG5EU`,
	"genre": `ReadMore_genre__nrN8W`,
	"pagination": `ReadMore_pagination__c6zjA`,
	"pageButton": `ReadMore_pageButton__kL+P0`,
	"nextButton": `ReadMore_nextButton__2Zic7`,
	"pageIndicator": `ReadMore_pageIndicator__rRj9x`,
	"loading": `ReadMore_loading__rKLpY`,
	"error": `ReadMore_error__6SlBC`
};
export default ___CSS_LOADER_EXPORT___;
